import React from 'react';
import Composer from './composer'
import Lists from './lists'
import Sender from './sender'

class Component extends React.Component {

  initialState = {
    tab: "lists"
  }

  componentWillMount() {
    // if (this.props.initial && this.props.user.role_id > 0) {
    //   this.props.api("affiliate/subaffiliates")  
    // }    
  }

  openTab = (tab,e) => {
    e.preventDefault()
    this.props.setState({tab})
  }

  render() {
    return (
      <div>
        <div class="nav-active-primary b-b b-primary">
          <ul class="nav nav-tabs">            
            <li class="nav-item">
              <a class={"nav-link "+(this.props.tab == "lists" ? "active " : "")} onClick={e => this.openTab("lists",e)}>
                Lists
              </a>                    
            </li>    
            <li class="nav-item">
              <a class={"nav-link "+(this.props.tab == "composer" ? "active " : "")} onClick={e => this.openTab("composer",e)}>
                Mail
              </a>                        
            </li>
            <li class="nav-item">
              <a class={"nav-link "+(this.props.tab == "sender" ? "active " : "")} onClick={e => this.openTab("sender",e)}>
                Sender
              </a>                        
            </li>                                 
          </ul>
        </div>
        <div class="tab-content">                
          <div class={"tab-pane pt-3 "+(this.props.tab == "lists" ? "active " : "")}><Lists /></div>
          <div class={"tab-pane pt-3 "+(this.props.tab == "composer" ? "active " : "")}><Composer /></div>
          <div class={"tab-pane pt-3 "+(this.props.tab == "sender" ? "active " : "")}><Sender curTab={this.props.state.tab} /></div>
        </div>
      </div>
    );
  }
}

import api from '../../actions/api'
import setState from '../../actions/state'
import { connect } from 'react-redux'

export default connect(function (state) {
  let apiState = state.api["mailer_load"] || state.api.initial;
  return {
    initial: apiState.initial,
    subaffiliates: apiState.items || [],
    apiState: apiState,
    state: state.state["mailer"] || state.state.initial,
    tab: state.state["mailer"] && state.state["mailer"].tab || "lists",
    user: state.session.user
  }
}, {api, setState: setState("mailer")})(Component)  